// extracted by css-extract-rspack-plugin
export default {"leftArrowBox":"_549c94c8","rightArrowBox":"_362e7f33","arrow":"_5491ee66"};